<template>
  <div>
    <div>
      <b-modal
        class="custprr"
        id="book-service-modal"
        hide-footer
        title="Choose Appointment"
      >
        <p class="text-center fsize20 mb-5">Would you like to proceed with ?</p>
        <div class="book-service-modal-main pb-8">
          <b-button
            @click="handleOpenDetailModal('online')"
            variant="primary"
            class=""
            >Online</b-button
          >
          <p class="pr-2 pt-1 fsize20">or</p>
          <b-button
            @click="handleOpenDetailModal('in-person')"
            variant="primary"
            class=""
            >In-Person</b-button
          >
          <!-- <b-form-radio-group
        v-model="selected"
        :options="options"
        class="mb-6"
        value-field="item"
        text-field="name"
        fill
        disabled-field="notEnabled"
      ></b-form-radio-group> -->
        </div>
      </b-modal>
      <!-- <b-modal id="google-sign-in-modal-3" hide-footer title="Auth with google">
        <GoogleLogin2 />
      </b-modal> -->
      <b-card no-body>
        <b-tabs pills card>
          <b-tab title="About" active
            ><b-card-text class="sm-fsize14">
              {{ get_volbyid.aboutServicePro }}</b-card-text
            ></b-tab
          >
          <!-- <b-tab title="Experience"
            ><b-card-text class="sm-fsize14">
              Caregiver Saathi™️ aims to empower family caregivers by creating
              an ecosystem of well-being and healing for the primary caregiver
              as well as for the care-receiver. We provide them the necessary
              guidance through educational content, tools, access to a
              community, support groups and professional home-care services that
              can help them lead a fuller life. Caregiver Saathi also partners
              with professional caregivers, healthcare practitioners,
              care-service providers, employers and well-wishers to build a
              supportive community to enable effective care.</b-card-text
            ></b-tab
          > -->
          <b-tab title="Review">
            <div>
              <swiper
                :options="swiperOption"
                class="related-product-swiper swiperrow_center overflow-x-auto my-16"
              >
                <swiper-slide
                  v-for="item in get_allreviewbyid"
                  :key="item.objectId"
                  class="border-2 rounded-lg border-none bg-white"
                >
                  <!-- Item Image -->
                  <div
                    class="p-4 cursor-pointer h-280 flex justify-center bx-shadow"
                  >
                    <div class="w-full relative">
                      <img
                        class="w-swiper m-auto"
                        :src="item.image"
                        :alt="item.name"
                        @click="toggleDetails(true, item)"
                      />

                      <p
                        class="letterspacing-2px mc-title font-bold text-start text-opacity fszie14px line-clamp3"
                        @click="toggleDetails(true, item)"
                      >
                        {{ item.review }}
                      </p>
                      <div class="absolute bottom-0 w-full">
                        <b-form-rating
                          id="rating-inline"
                          inline-value="4"
                          size="sm"
                          color="#f3ca63"
                          disabled
                          v-model="item.rating"
                          class="border-none w-1/2"
                        ></b-form-rating>
                        <div class="flex items-center mt-4">
                          <img
                            :src="
                              item.profile
                                ? $imageURL + '/' + item.profile
                                : require('@/assets/images/blank-profile.png')
                            "
                            :alt="item.userId.firstname"
                            class="w-10 radius25px"
                          />
                          <div class="user-info ml-2">
                            <h3 class="font-semibold fszie14px">
                              {{ item.userId.firstname }}
                              {{ item.userId.lastname }}
                            </h3>
                            <span class="fszie11px">{{ item.createdAt }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </swiper-slide>

                <div
                  class="swiper-button-prev cust-hidden"
                  slot="button-prev"
                ></div>
                <div
                  class="swiper-button-next cust-hidden"
                  slot="button-next"
                ></div>
              </swiper></div
          ></b-tab>
          <!-- <b-tab title="Expertise">
            <b-card-text class="fsize14">{{
              get_volbyid.experties
            }}</b-card-text>
          </b-tab> -->
          <!-- <b-tab title="Course Completed">
            <b-card-text class="fsize14">{{
              get_volbyid.courseCompleted
            }}</b-card-text>
          </b-tab> -->
        </b-tabs>
      </b-card>
      <!-- <div
        class="btn-footer flex justify-center py-2"
        v-if="
          this.get_volbyid.hasOwnProperty('dateTimeSlots') &&
          !this.get_volbyid.dateTimeSlots.hasOwnProperty('types')
        "
      >
        <b-button
          class="mt-8 btn-book p-book bg-primary"
          @click.stop="handleView(get_volbyid._id)"
          >Book Appointment</b-button
        >
      </div>
      <div class="btn-footer flex justify-center py-2" v-else>
        <b-button
          class="mt-8 btn-book p-book text-white bg-danger"
          type="primary"
          disabled
          >Not Available</b-button
        >
      </div> -->
    </div>
    <!-- <b-tabs content-class="mt-12" justified>
      <b-tab title="Experience" active
        ><p>
          Caregiver Saathi™️ aims to empower family caregivers by creating an
          ecosystem of well-being and healing for the primary caregiver as well
          as for the care-receiver. We provide them the necessary guidance
          through educational content, tools, access to a community, support
          groups and professional home-care services that can help them lead a
          fuller life. Caregiver Saathi also partners with professional
          caregivers, healthcare practitioners, care-service providers,
          employers and well-wishers to build a supportive community to enable
          effective care.
        </p></b-tab
      >
      <b-tab title="Review">
        <b-textarea>{{ get_volbyid.courseCompleted }}</b-textarea>
      </b-tab>
      <b-tab title="Experties"
        ><p>
          {{ get_volbyid.experties }}
        </p></b-tab
      >
      <b-tab title="Course Completed"
        ><p>
          {{ get_volbyid.courseCompleted }}
        </p></b-tab
      >
    </b-tabs>

    <div class="btn-footer flex justify-center">
      <b-button
        class="mt-8 btn-book p-book"
        @click.stop="handleView(get_volbyid._id)"
        >Book Appointment</b-button
      >
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import GoogleLogin2 from "../../schedule/components/GoogleLogin2.vue";
export default {
  components: {
    swiper,
    swiperSlide,
    GoogleLogin2,
  },

  data() {
    return {
      selectedExclusive: {},
      isDetailsActive: false,
      swiperOption: {
        slidesPerView: 2.5,
        observer: true,
        observeParents: true,
        spaceBetween: 25,
        breakpoints: {
          1600: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 55,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 55,
            slidesPerColumn: 1,
          },
        },

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      related_items: [
        {
          //   name: "Template 1",
          text: "There are only four kinds of people in the world. Those who have been caregivers.There are only four kinds of people in the world. Those who have been caregivers.There are only four kinds of people in the world. Those who have been caregivers.",
          //   image: require("@/assets/images/logo.png"),
        },
        {
          //
          text: "There are only four kinds of people in the world. Those who have been caregivers.There are only four kinds of people in the world. Those who have been caregivers.",
        },
        {
          //   name: "Template 3",
          //   image: require("@/assets/images/logo.png"),
          text: "There are only four kinds of people in the world. Those who have been caregivers.There are only four kinds of people in the world. Those who have been caregivers.",
        },
        {
          //   name: "Template 4",
          //   image: require("@/assets/images/logo.png"),
          text: "There are only four kinds of people in the world. Those who have been caregivers.There are only four kinds of people in the world. Those who have been caregivers.",
        },
        {
          //   name: "Template 5",
          //   image: require("@/assets/images/logo.png"),
          text: "There are only four kinds of people in the world. Those who have been caregivers.There are only four kinds of people in the world. Those who have been caregivers.",
        },
        {
          //   name: "Template 6",
          //   image: require("@/assets/images/logo.png"),
          text: "There are only four kinds of people in the world. Those who have been caregivers.There are only four kinds of people in the world. Those who have been caregivers.",
        },
        {
          //   name: "Template 7",
          //   image: require("@/assets/images/logo.png"),
          text: "There are only four kinds of people in the world. Those who have been caregivers.There are only four kinds of people in the world. Those who have been caregivers.",
        },
        {
          //   name: "Template 8",
          //   image: require("@/assets/images/logo.png"),
          text: "There are only four kinds of people in the world. Those who have been caregivers.There are only four kinds of people in the world. Those who have been caregivers.",
        },
      ],
    };
  },
  methods: {
    init() {
      // console.log(this.get_allreviewbyid);
    },
    handleOpenDetailModal(val) {
      this.selected = val;
      if (val == "online") {
        this.getAuth();
        //this.$bvModal.show("google-sign-in-modal-3");
      } else {
        this.$router.push({
          name: "schedule-page",
        });
      }
    },
    async handleView(item) {
      this.$bvModal.show("book-service-modal");
      let price;
      if (this.$route.query.service) {
        price =
          this.getUserByUserId.currentMembership &&
          this.serviceDiscount.hasOwnProperty(
            this.getUserByUserId.currentMembership.name
          )
            ? this.get_volbyid.price -
              (this.get_volbyid.price *
                Number(
                  this.serviceDiscount[
                    this.getUserByUserId.currentMembership.name
                  ]
                )) /
                100
            : this.get_volbyid.price;
      } else {
        price = this.get_volbyid.price;
      }
      // this.$router.push({
      //   name: "schedule-page",
      // });
      this.$store.commit("auth/SESSION_PRICE", price);
    },
    async getAuth() {
      try {
        let res = await this.$store.dispatch("google/getAuthUrl", {
          redirectURL: this.$webURL + "/schedule-page",
          scopes: [
            "https://www.googleapis.com/auth/calendar",
            "https://www.googleapis.com/auth/calendar.events",
          ],
        });
        window.open(res.data, "_self");
      } catch (error) {
        console.log(error);
      }
    },
    async getToken(code) {
      try {
        let data = await this.$store.dispatch("google/getToken", {
          redirectURL: this.$webURL + "/schedule-page",
          code: code,
        });
        if (data.code === 200) {
          window.localStorage.setItem("isGoogleSigned", true);
          this.$store.commit("google/SET_GOOGLE_AUTH", {
            access_token: data.data,
            scope: decodeURIComponent(this.$route.query.scope),
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    ...mapState("respitecare", {
      get_volbyid: "get_volbyid",
      get_allreviewbyid: "get_allreviewbyid",
      getVolunteerByService: "getVolunteerByService",
      serviceDiscount: "serviceDiscount",
    }),
    ...mapState("services", { get_AllService: "get_AllService" }),
    ...mapState("auth", { user: "user", getUserByUserId: "getUserByUserId" }),
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.book-service-modal-main {
  display: flex;
  justify-content: center;
  align-content: center;
}
.h-280 {
  height: 280px;
}
.radius25px {
  border-radius: 25px;
}
.fszie14px {
  font-size: 14px;
}
.fszie12px {
  font-size: 14px;
}
.fszie11px {
  font-size: 11px;
}
.text-opacity {
  color: #121127;
  opacity: 56%;
}
.line-clamp3 {
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.bx-shadow {
  box-shadow: 0px 4px 15px 0px rgb(0 0 0 / 10%);
}
.cust-hidden {
  display: none;
}
.btn-book {
  color: #ffffff;
  background-color: #4f0a4b;
}
.btn-book:hover {
  color: #ffffff;
  background-color: #3b0839;
}
.p-book {
  padding: 17px 55px;
}
@media (max-width: 641px) {
  .card-header {
    padding: 1rem;
  }
  .nav-pills .nav-item {
    margin-bottom: 0rem;
  }
  .nav-pills .nav-link {
    padding: 0.5rem;
  }
  .nav-pills .nav-item:not(:last-child) {
    margin-right: 4px;
  }
}
.close {
  color: #4f0a4b !important;
}
#book-service-modal .modal-body {
  padding: 0;
}
#book-service-modal .modal-title {
  font-size: 24px !important;
}
</style>
